import { combineReducers } from 'redux';
import { merge } from 'lodash'
import { normalize, schema } from 'normalizr';

// Define a archives schema
const archiveSchema = new schema.Entity('archives', {}, { idAttribute: 'id' });
const archiveListSchema = [archiveSchema];

const defaultVtypeParams = {
  archiveFetched: false,
  downloadMsg: null,
}


function byId(state = {}, action) {
  if (action.type === 'SAVED_ARCHIVE') {
    let archiveId = action.payload.id
    return {
      ...state,
      [archiveId]: action.payload
    }

  }
  if (action.type === 'FETCHED_ARCHIVE') {
    // const normalizedVtype = normalize(action.payload, archiveListSchema);
    // return merge({}, state, normalizedVtype.entities.archives)
    return action.payload
  }
  if (action.type === 'DELETED_ARCHIVE') {
    if (action.payload.msg === "Success") {
      const archiveID = action.payload.id;
      return {
        ...state,
        [archiveID]: {
          ...state[archiveID],
          status: 0
        }
      }
    } else {
      return state
    }
  }
  if (action.type === 'RESET_DATA') {
    return {}
  } else {
    return state
  }
}

function saveEditedResponse(state = {}, action) {
  if (action.type === 'SAVED_ARCHIVE_RES') {
    return action.payload
  } else {
    return state
  }
}


function notifications(state = {}, action) {
  if (action.type === 'SAVED_SEGMAP') {

    return {
      ...state,
      [action.payload.id]: {
        ...state[action.payload.id],
        save: {
          status: (action.txn === "success" || action.txn === "Success") ? 'success' : 'error',
          msg: action.txn
        }
      }
    }
  }
  if (action.type === 'DELETED_ARCHIVE') {
    return {
      ...state,
      [action.payload.id]: {
        ...state[action.payload.id],
        delete: {
          status: action.payload.msg === "Success" ? 'success' : 'error',
          msg: action.payload.msg
        }
      }
    }
  }
  if (action.type === 'NOTIFICATION_DONE_ARCHIVE') {
    const { id, type } = action.payload
    // Remove the 'id' element from state
    const { [id]: idValue, ...restOfState } = state;
    // Remove the 'type' from the 'id' element
    const { [type]: removedValue, ...restOfId } = idValue;
    // Merge back together
    const finalState = { ...restOfState, [id]: restOfId };
    return finalState

  } else {
    return state
  }
}


function params(state = defaultVtypeParams, action) {
  if (action.type === 'FETCHED_ARCHIVE') {
    return {
      ...state,
      archiveFetched: true,
      isFetching: false
    }
  }
  if (action.type === 'FETCH_ARCHIVE') {
    return {
      ...state,
      archiveFetched: false,
      isFetching: false
    }
  }
  if (action.type === 'DELETED_ARCHIVE') {
    return {
      ...state,
      isDelFetched: true
    }
  }
  if (action.type === 'FETCHED_DOWNLOAD_ARCHIVE') {
    return {
      ...state,
      downloadMsg: action.payload
    }
  }
  if (action.type === 'RESET_DATA') {
    return defaultVtypeParams
  } else {
    return state
  }
}

const archive = combineReducers({
  byId,
  // notifications,
  params,
  // saveEditedResponse,
});

export default archive;

